import { Metamodel } from '../../base/model';

export enum AdsDatasetType {
    AdlsGen2Filesystem = 'AdlsGen2Filesystem',
    AdlsGen2File = 'AdlsGen2File',
    AdlsGen2Folder = 'AdlsGen2Folder'
}

export interface IAdsDatasetArgs<IProperties> {
    readonly name: string;
    readonly datasetType: AdsDatasetType;
    readonly properties: IProperties;
}

@Metamodel.model({
    name: 'AdsDataset'
})
export abstract class AdsDataset<SpecificDatasetProperties = {}> {
    public name: string;
    public datasetType: AdsDatasetType;
    public properties: SpecificDatasetProperties;

    public readonly abstract resourceId: string;

    public constructor(args: IAdsDatasetArgs<SpecificDatasetProperties>) {
        this.name = args.name;
        this.datasetType = args.datasetType;
        this.properties = args.properties;
    }

    public renameTo(newName: string): void {
        this.name = newName;
    }

}
